import React from "react";
import { Modal } from "antd";

const DeleteVideoModal = ({ visible, onCancel, onConfirm }) => {
  return (
    <Modal
      title="Delete Video"
      open={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Delete"
      okButtonProps={{ danger: true }}
    >
      <p>
        Are you sure you want to delete this video? This action cannot be
        undone.
      </p>
    </Modal>
  );
};

export default DeleteVideoModal;
